import { useState } from "react";
import { FaChevronDown, FaChevronUp, FaFacebookF } from "react-icons/fa";
import zaloIcon from "@/assets/images/zalo-icon.png";
import { useNavigate } from "react-router";
import { FormattedMessage } from "react-intl";

const Information = () => {
  const navigate = useNavigate();
  const [openQuick, setOpenQuick] = useState(false);
  const [openOther, setOpenOther] = useState(false);
  return (
    <div
      className="w-full flex justify-center bg-[#031602]"
      style={{ fontFamily: "Lexend Deca, sans-serif" }}
    >
      <div className="w-full max-w-[1536px] m-auto flex flex-col md:flex-row justify-between items-center gap-8 px-4 py-12 text-white">
        {/* Cột 1: Thông tin công ty */}
        <div className="flex-1 flex flex-col items-start min-w-[356px]">
          <div className="flex items-center gap-3 mb-4">
            <span className="flex items-center justify-center">
              <img
                src="/media/images/landing-page/bot-icon-1.png"
                alt="chat_bot"
                className="w-[41px] h-[41px] md:w-[52px] md:h-[52px]"
              />
            </span>
            <div>
              <div className="text-2xl font-normal text-[#5AE65E] leading-tight tracking-wide">
                CHATME.VN
              </div>
              <div className="text-lg text-white tracking-wide">AI CHATBOT</div>
            </div>
          </div>
          <div className="text-sm mb-4 leading-relaxed">
            <FormattedMessage id="LANDINGPAGE.FOOTER.COMPANY_NAME" />
          </div>
          <div className="text-sm mb-4 leading-relaxed">
            <FormattedMessage id="LANDINGPAGE.FOOTER.BUSINESS_REGISTRATION" />
          </div>
          <div className="flex items-start gap-3 text-sm">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mt-1 flex-shrink-0"
            >
              <path
                d="M8.00001 0C4.80485 0 2.20541 2.59944 2.20541 5.79456C2.20541 9.75981 7.39101 15.581 7.61179 15.8269C7.81916 16.0579 8.18123 16.0575 8.38823 15.8269C8.60901 15.581 13.7946 9.75981 13.7946 5.79456C13.7945 2.59944 11.1951 0 8.00001 0ZM8.00001 14.679C6.25479 12.606 3.24891 8.516 3.24891 5.79462C3.24891 3.17481 5.38023 1.0435 8.00001 1.0435C10.6198 1.0435 12.7511 3.17481 12.7511 5.79459C12.7511 8.51609 9.74566 12.6053 8.00001 14.679Z"
                fill="white"
              />
              <path
                d="M8 2.87939C6.39244 2.87939 5.08463 4.18724 5.08463 5.7948C5.08463 7.40236 6.39247 8.71021 8 8.71021C9.60753 8.71021 10.9153 7.40236 10.9153 5.7948C10.9153 4.18724 9.60753 2.87939 8 2.87939ZM8 7.66671C6.96781 7.66671 6.12813 6.82699 6.12813 5.7948C6.12813 4.76261 6.96784 3.92289 8 3.92289C9.03216 3.92289 9.87188 4.76261 9.87188 5.7948C9.87188 6.82699 9.03216 7.66671 8 7.66671Z"
                fill="white"
              />
            </svg>
            <span>
              <FormattedMessage id="LANDINGPAGE.FOOTER.HEADQUARTERS" />
            </span>
          </div>
        </div>

        {/* Cột 2: Chính sách và quy định */}
        <div className="flex-1 min-w-[454px] hidden md:block">
          <div className="text-2xl font-normal text-[#5AE65E] mb-6 tracking-wide uppercase">
            <FormattedMessage id="LANDINGPAGE.FOOTER.POLICY_AND_REGULATIONS" />
          </div>
          <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-sm text-white">
            <div className="cursor-pointer hover:text-[#5AE65E]">
              <FormattedMessage id="LANDINGPAGE.FOOTER.FEATURES" />
            </div>
            <div
              onClick={() => navigate("/terms-and-conditions")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.TERMS_AND_CONDITION" />
            </div>
            <div
              onClick={() => navigate("/pricing")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.PRICING" />
            </div>
            <div
              onClick={() => navigate("/privacy-policy")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.PRIVACY_POLICY" />
            </div>
            <div className="cursor-pointer hover:text-[#5AE65E]">
              <FormattedMessage id="LANDINGPAGE.FOOTER.USER_GUIDE" />
            </div>
            <div
              onClick={() => navigate("/complaint-handling")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.COMPLAINT_HANDLING" />
            </div>
            <div
              onClick={() => navigate("/payment")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.PAYMENT" />
            </div>
            <div
              onClick={() => navigate("/payment-policy")}
              className="cursor-pointer hover:text-[#5AE65E]"
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.PAYMENT_POLICY" />
            </div>
          </div>
        </div>

        {/* Cột 3: Dịch vụ khác */}
        <div className="flex-1 min-w-[200px] hidden md:block">
          <div className="text-2xl font-normal text-[#5AE65E] mb-6 tracking-wide uppercase">
            <FormattedMessage id="LANDINGPAGE.FOOTER.OTHER_SERVICES" />
          </div>
          <div className="space-y-3 text-sm text-white">
            <div className="cursor-pointer hover:text-[#5AE65E]">Voizo</div>
            <div className="cursor-pointer hover:text-[#5AE65E]">
              LMS - Elearning
            </div>
            <div className="cursor-pointer hover:text-[#5AE65E]">Unipo</div>
            <div className="cursor-pointer hover:text-[#5AE65E]">CallBot</div>
          </div>
        </div>

        {/* Cột 4: Liên hệ */}
        <div className="flex-1 min-w-[200px] hidden md:block">
          <div className="text-2xl font-normal text-[#5AE65E] mb-6 tracking-wide uppercase">
            <FormattedMessage id="LANDINGPAGE.FOOTER.CONTACT" />
          </div>
          <div className="space-y-4 text-sm text-white">
            <div className="flex items-center gap-3">
              <svg
                width="16"
                height="12"
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5938 0H1.40625C0.629281 0 0 0.633187 0 1.40625V9.84375C0 10.6214 0.633906 11.25 1.40625 11.25H14.5938C15.3642 11.25 16 10.6241 16 9.84375V1.40625C16 0.634562 15.3732 0 14.5938 0ZM14.3968 0.9375C14.1095 1.22328 9.16509 6.14166 8.99438 6.31147C8.72875 6.57709 8.37562 6.72334 8 6.72334C7.62437 6.72334 7.27125 6.57706 7.00475 6.31059C6.88994 6.19637 2.00009 1.33231 1.60319 0.9375H14.3968ZM0.9375 9.65294V1.59766L4.98869 5.6275L0.9375 9.65294ZM1.60378 10.3125L5.65338 6.28866L6.34272 6.97437C6.78541 7.41706 7.37397 7.66084 8 7.66084C8.62603 7.66084 9.21459 7.41706 9.65641 6.97525L10.3466 6.28866L14.3962 10.3125H1.60378ZM15.0625 9.65294L11.0113 5.6275L15.0625 1.59766V9.65294Z"
                  fill="white"
                />
              </svg>
              <span>Support@Cyberuni.vn</span>
            </div>
            <div className="flex items-center gap-3">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_11_5635)">
                  <path
                    d="M3.2603 10.6357C4.83841 12.5222 6.73812 14.0075 8.90638 15.0584C9.73191 15.4496 10.8359 15.9138 12.0659 15.9934C12.1422 15.9967 12.2151 16 12.2914 16C13.1169 16 13.78 15.7149 14.3204 15.1281C14.3237 15.1247 14.3303 15.1181 14.3336 15.1115C14.5259 14.8794 14.7448 14.6705 14.9735 14.4484C15.1293 14.2992 15.2885 14.1434 15.441 13.9843C16.1472 13.2482 16.1472 12.3133 15.4344 11.6005L13.4418 9.60796C13.1036 9.25653 12.6992 9.07087 12.2748 9.07087C11.8504 9.07087 11.4426 9.25653 11.0945 9.60464L9.90762 10.7915C9.79821 10.7286 9.68549 10.6722 9.5794 10.6191C9.44678 10.5528 9.32412 10.4898 9.21471 10.4202C8.1339 9.73394 7.15255 8.83879 6.21429 7.68835C5.7402 7.08827 5.42192 6.58433 5.19979 6.07045C5.51144 5.78864 5.80319 5.49358 6.085 5.20514C6.18446 5.10236 6.28723 4.99959 6.39001 4.89681C6.74807 4.53875 6.94036 4.12433 6.94036 3.70327C6.94036 3.28222 6.75139 2.8678 6.39001 2.50974L5.40203 1.52176C5.28599 1.40572 5.17658 1.293 5.06386 1.17696C4.84505 0.951513 4.61628 0.719436 4.39084 0.510568C4.04936 0.175715 3.64819 0 3.22383 0C2.80277 0 2.3983 0.175715 2.04355 0.513883L0.803603 1.75383C0.352712 2.20472 0.097428 2.75176 0.044382 3.385C-0.0186101 4.17737 0.127266 5.01948 0.505219 6.0373C1.08541 7.6121 1.96067 9.07418 3.2603 10.6357ZM0.853334 3.45462C0.893118 3.01368 1.0622 2.64567 1.38048 2.32739L2.6138 1.09407C2.80609 0.908413 3.01827 0.812267 3.22383 0.812267C3.42606 0.812267 3.63162 0.908413 3.82059 1.1007C4.04272 1.30626 4.25159 1.52176 4.47704 1.75052C4.58976 1.86656 4.7058 1.98259 4.82184 2.10195L5.80982 3.08993C6.01537 3.29548 6.12146 3.50435 6.12146 3.7099C6.12146 3.91546 6.01537 4.12433 5.80982 4.32988C5.70704 4.43266 5.60427 4.53875 5.50149 4.64152C5.19316 4.95317 4.90472 5.24824 4.58645 5.53005C4.57982 5.53668 4.5765 5.53999 4.56987 5.54662C4.29469 5.8218 4.33779 6.08371 4.4041 6.28264C4.40742 6.29258 4.41073 6.29921 4.41405 6.30916C4.66933 6.9225 5.02408 7.50601 5.57774 8.20224C6.57236 9.42893 7.62001 10.3804 8.77376 11.1131C8.91633 11.206 9.06883 11.2789 9.21139 11.3518C9.34401 11.4182 9.46668 11.4811 9.57608 11.5508C9.58935 11.5574 9.59929 11.564 9.61255 11.5707C9.72196 11.627 9.82805 11.6535 9.93415 11.6535C10.1994 11.6535 10.3718 11.4845 10.4281 11.4281L11.6681 10.1881C11.8604 9.99586 12.0692 9.89308 12.2748 9.89308C12.5268 9.89308 12.7323 10.0489 12.8616 10.1881L14.8608 12.184C15.2586 12.5818 15.2553 13.0128 14.8508 13.4339C14.7116 13.5831 14.5657 13.7257 14.4099 13.8748C14.1778 14.1003 13.9358 14.3324 13.717 14.5943C13.3357 15.0054 12.8815 15.1977 12.2947 15.1977C12.2383 15.1977 12.1787 15.1944 12.1223 15.191C11.0349 15.1214 10.0237 14.6971 9.26444 14.3357C7.20228 13.3378 5.39208 11.9221 3.89022 10.1252C2.65358 8.63655 1.82142 7.25072 1.27107 5.76544C0.929587 4.85371 0.800288 4.12101 0.853334 3.45462Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_11_5635">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span>0865526282</span>
            </div>
          </div>
          <div className="flex gap-4 mt-6">
            <a
              href="https://zalo.me/0865526282"
              target="_blank"
              rel="noopener noreferrer"
              className="shadow-lg transition-colors"
            >
              <img src={zaloIcon} alt="Zalo" className="size-8" />
            </a>
            <a
              href="https://www.facebook.com/share/161nNzwFYQ/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 rounded-full p-2 size-8 text-white shadow-lg hover:bg-blue-700 transition-colors"
            >
              <FaFacebookF />
            </a>
          </div>
        </div>

        {/* Mobile: Accordion */}
        <div className="md:hidden w-full mt-8">
          <div className="mb-4">
            <button
              className="flex items-center justify-between w-full text-lg text-[#5AE65E] mb-2"
              onClick={() => setOpenQuick((v) => !v)}
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.POLICY_AND_REGULATIONS" />
              <span className="ml-2">
                {openQuick ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </button>
            <div
              className={`grid grid-cols-2 gap-x-6 gap-y-2 text-sm transition-all duration-300 overflow-hidden ${openQuick ? "max-h-40" : "max-h-0"}`}
            >
              <div className="cursor-pointer hover:text-[#5AE65E]">
                <FormattedMessage id="LANDINGPAGE.FOOTER.FEATURES" />
              </div>
              <div
                onClick={() => navigate("/terms-and-conditions")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.TERMS_AND_CONDITIONS" />
              </div>
              <div
                onClick={() => navigate("/pricing")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.PRICING" />
              </div>
              <div
                onClick={() => navigate("/privacy-policy")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.PRIVACY_POLICY" />
              </div>
              <div className="cursor-pointer hover:text-[#5AE65E]">
                <FormattedMessage id="LANDINGPAGE.FOOTER.USER_GUIDE" />
              </div>
              <div
                onClick={() => navigate("/complaint-handling")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.COMPLAINT_HANDLING" />
              </div>
              <div
                onClick={() => navigate("/payment")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.PAYMENT" />
              </div>
              <div
                onClick={() => navigate("/payment-policy")}
                className="cursor-pointer hover:text-[#5AE65E]"
              >
                <FormattedMessage id="LANDINGPAGE.FOOTER.PAYMENT_POLICY" />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <button
              className="flex items-center justify-between w-full text-lg text-[#5AE65E] mb-2"
              onClick={() => setOpenOther((v) => !v)}
            >
              <FormattedMessage id="LANDINGPAGE.FOOTER.OTHER_SERVICES" />
              <span className="ml-2">
                {openOther ? <FaChevronUp /> : <FaChevronDown />}
              </span>
            </button>
            <div
              className={`space-y-2 text-sm transition-all duration-300 overflow-hidden ${openOther ? "max-h-40" : "max-h-0"}`}
            >
              <div className="cursor-pointer hover:text-[#5AE65E]">Voizo</div>
              <div className="cursor-pointer hover:text-[#5AE65E]">
                LMS - Elearning
              </div>
              <div className="cursor-pointer hover:text-[#5AE65E]">Unipo</div>
              <div className="cursor-pointer hover:text-[#5AE65E]">CallBot</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
